import { BiddingIntradayCsvRowStatus } from '@ebalance/proto/bffuser/v1/bidding_intraday_model_pb'

import { BidCsvConfirmRejection } from '~/components/bidding/common/BidCsvConfirmRejection'
import { IntradayCsvRowStatusBadge } from '~/pages/IntradayCsvImport/components/PreviewTable'
import {
  type IntradayConfirmRejection,
  shouldRetryLater,
} from '~/pages/IntradayCsvImport/models/confirmRejection'

/**
 * 確定時の再検証で取込全体が拒否された時の確定モーダル本文 (issue #8786 Des 判断 1〜4、
 * spec AC-BCI-035)。 表示はスポット入札と共有の `BidCsvConfirmRejection` で、 ここは
 * error detail から取り出した行エラーとファイル全体の理由を渡すだけ。
 * 見出しの件数は、 行エラーのある行の数 (1 行に複数の違反があっても 1 行と数える)。
 * 行エラーがすべて時間をおくと解消する原因 (開場前・基準価格の値が無い。 AC-BCI-030 / 032)
 * の時は、 CSV を直す案内ではなく「時間をおいてから、 取り込み直す」案内を出す (spec §7)。
 */
export const CsvConfirmRejection = ({
  rowErrors,
  fileMessages,
}: IntradayConfirmRejection): React.ReactElement => (
  <BidCsvConfirmRejection
    errorBadge={
      <IntradayCsvRowStatusBadge status={BiddingIntradayCsvRowStatus.ERROR} />
    }
    errorRowCount={
      new Set(rowErrors.map((rowError) => rowError.rowNumber)).size
    }
    fileReasons={fileMessages}
    retryLater={shouldRetryLater({ rowErrors, fileMessages })}
    rowMessages={rowErrors.map((rowError) => rowError.message)}
  />
)
